package com.eladfinish.bible.contest.screens.browse.usecases

import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.constants.StringConstants.NO_BREAK_SPACE
import com.eladfinish.bible.contest.extensions.replaceRegex
import com.eladfinish.bible.contest.utils.getRegexOfSingleOtPasuk
import com.eladfinish.bible.contest.utils.replaceOtiotPasuk
import com.eladfinish.bible.contest.utils.toOtiot

class RenumberOtiotPasukUseCase {

    operator fun invoke(content: String): String {
        return content
            .replaceRegex(regex = StringConstants.Regex.PEREK, replacement = "")
            .replaceOtiotPasuk(literalReplacement = "")
            .replaceRegex(regex = getRegexOfSingleOtPasuk(), replacement = "")
            .replaceRegex(regex = "\\s+", replacement = " ")
            .trim()
            .renumberOtiotPasuk()
    }

    private fun String.renumberOtiotPasuk(): String {
        return split(StringConstants.COLON_SPLITTER)
            .filter { it.isNotBlank() }
            .mapIndexed { index, pasuk ->
                (index + 1).toOtiot() + NO_BREAK_SPACE + pasuk + StringConstants.COLON_SPLITTER
            }.joinToString(separator = " ")
            .trim()
    }
}
